import type { Store } from 'effector'
import type { CurrentTvShowWithPriceFormatted } from './index.h'

import { api } from '@setplex/tria-api'
import { combine, createEvent, sample } from 'effector'
import { model as i18n } from '~/core/i18n'
import { ssePurchasesModel } from '~/features/payment/sse-purchases'
import { extendMediaItemByLabelPrice } from '~/shared/tools'
import { formatCategoryWithShowsToUi, formatCurrentShow } from './lib'

// *
// * EVENTS
// *

export const loadTvShow = createEvent<{
  tvShowId: number
}>()

// *
// * CONNECTIONS
// *

sample({
  clock: loadTvShow,
  target: api.tvshows.getTvShowFx,
})

// *
// * STORES
// *

// store with slightly adjusted current tv show
export const $currentShow: Store<CurrentTvShowWithPriceFormatted | null> =
  combine(api.tvshows.$currentTvShow, i18n.$t, (current, { t }) =>
    current ? formatCurrentShow({ current, t }) : null
  )

export const $infiniteShowsFormatted = combine(
  api.tvshows.$infiniteShowsCategory,
  ssePurchasesModel.$tvShow,
  i18n.$t,
  (data, adjust, { t }) => formatCategoryWithShowsToUi(data, adjust, t)
)

export const $infiniteShowsTitle: Store<string> = combine(i18n.$t, ({ t }) =>
  t('all')
)

export const $lastAddedTvShowsFormatted = combine(
  api.tvshows.$lastAddedTvShows,
  ssePurchasesModel.$tvShow,
  (tvShows, adjust) =>
    tvShows.map((tvShow) => extendMediaItemByLabelPrice(adjust(tvShow)))
)
